import { Button, theme } from 'antd'
import { useState } from 'react'
import useWindowSize from '../../../../../../../hooks/window-size-hook'
import IconGlobalApp from '../../../../../../../utils/IconGlobalApp'
import useGetDataProjectMember from './use-get-data-project-member'
import formatNumberWithDecimal from '../../../../../../../utils/format-number-with-decimal'
import ModalMemberManagement from '../components/Modal.MemberManagement'
import useProjectStore from '../../../project.store'

const useControlProjectMemberManagement = (projectId: string | undefined) => {
  const themeToken = theme.useToken().token
  const { isSmallSize } = useWindowSize({ options: { needWindowSize: false } })

  const [open, setOpen] = useState(false)

  const { members, projectDetail: unCheckProjectDetail } = useProjectStore()

  const projectDetail =
    unCheckProjectDetail?.id === projectId ? unCheckProjectDetail : undefined

  const { getData, loading } = useGetDataProjectMember({
    projectId,
    autoGetFullData: true,
    customRequestHandler: true,
  })

  const getMembers = () => getData({ type: 'fetch' })

  const memberButton = projectDetail ? (
    <Button
      size={isSmallSize ? 'small' : 'middle'}
      icon={
        <IconGlobalApp name="users-round" color={themeToken.colorPrimary} />
      }
      loading={loading}
      onClick={() => setOpen(true)}
    >
      {formatNumberWithDecimal((members ?? []).length)}
      {isSmallSize ? '' : ' Thành viên'}
    </Button>
  ) : null

  const memberModal = projectDetail ? (
    <ModalMemberManagement
      project={projectDetail}
      members={members}
      open={open}
      loading={loading}
      onCancel={() => setOpen(false)}
      onFinish={() => getData({ type: 're-fetch' })}
    />
  ) : null

  const controlOpen = (isOpen: boolean) => setOpen(isOpen)

  return {
    loading,
    controlOpen,
    getMembers,
    memberButton,
    memberModal,
  }
}

export default useControlProjectMemberManagement
